import { DetailedHTMLProps, HTMLAttributes, useState } from "react"

export const Checkbox = ({
  isChecked = false,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  isChecked: boolean
}) => {
  const [checked, setChecked] = useState(isChecked)
  return (
    <div {...props}>
      <div
        className={`tw-rounded tw-h-5 tw-w-5 ${
          checked ? "tw-bg-primary" : "tw-border-2 tw-border-primary-50"
        }`}
        onClick={() => setChecked(!checked)}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 16 20'
          fill='none'
          data-testid='svg'
        >
          <path
            d='M13.3334 4L6.00008 11.3333L2.66675 8'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
    </div>
  )
}
